export default {
  specialty: [
    {
      name: 'Daraprim',
      ndc: '69413033030',
      gpi: '13000040000310',
      icds: ['R10', 'A57', 'G36.9', 'W23'],
    },
    {
      name: 'Humira',
      ndc: '00074379902',
      gpi: '6627001500F820',
      icds: ['B47.1', 'B57.0', 'N31.2', 'M71.072'],
    },
    {
      name: 'Eliquis',
      ndc: '00003089331',
      gpi: '83370010000320',
      icds: ['J45.991', 'E10.331', 'E11.329', 'I25.72'],
    },
    {
      name: 'Biktarvy',
      ndc: '61958250103',
      gpi: '12109903240330',
      icds: ['A22.9', 'J85.1', 'P23.3', 'G71.20'],
    },
    {
      name: 'Otezla',
      ndc: '55513013760',
      gpi: '66700015000330',
      icds: ['E67.0', 'Q33.3', 'V98.1', 'S06.0x75'],
    },
    {
      name: 'Xyrem',
      ndc: '68727010001',
      gpi: '62450060202020',
      icds: ['C84.7', 'N18.2', 'D89.810', 'L12.1'],
    },
    {
      name: 'Increlex',
      ndc: '15054104005',
      gpi: '30160045002020',
      icds: ['A80', 'V32.5xxD', 'Q13.5', 'D69.0'],
    },
  ],
  rs: [
    {
      name: 'Eliquis',
      ndc: '00003089331',
      gpi: '83370010000320',
      icds: ['J45.991', 'E10.331', 'E11.329', 'I25.72'],
    },
  ],
};
